// the chunk loading error is a special case - the user might be able to do something about it.
export function isChunkLoadingError(error: Error): boolean {
  // note that in React development mode, the error messages are different to production, so this won't work.
  return error.name === 'ChunkLoadError';
}
